const ToggleAnime = require('../velocity/toggle-anime');
const { displayMoment } = require('../modules/element-operate');

/**
 * ToTop
 * @class
 */
class ToTop {

  /**
   * @static
   * @return {object} default options
   */
  static get defOpts() {
    return {
      selectors: {
        showPoint: 'js-to-top-show-point',  // null is set showPoint
        stopPoint: 'js-to-top-stop-point',
      },
      showPoint: null,  // null is set selectors.showPoint
      animeOpts: {
        duration  : 300,
        easing    : 'linear',
      },
    }
  };

  /**
   * @instance
   * @param el {string|HTMLElement} element
   * @param opts {object} options
   */
  constructor(el, opts = {}) {
    const { selectors, showPoint, animeOpts } = _.defaults(opts, ToTop.defOpts);

    this.el          = el;
    this.stopPointEl = document.getElementsByClassName(selectors.stopPoint)[0];
    if(selectors.showPoint){
      this.showPointEl = document.getElementsByClassName(selectors.showPoint)[0];
    }

    this.showPoint   = showPoint;
    this.animeOpts   = animeOpts;

    this.createAnime();

    window.addEventListener('load', this.onWindowLoaded.bind(this), false);
    window.addEventListener('resize', this.reset.bind(this), false);
  }

  /**
   * @instance
   * @private
   */
  createAnime() {
    this.toggleAnime = new ToggleAnime({
      $el  : this.el,
      anime: [
        { opacity: 1 },
        { opacity: 0 },
      ],
      opts : this.animeOpts,
    });
  }

  /**
   * @instance
   * @private
   */
  onWindowLoaded() {
    displayMoment(this.el, () => {
      this.elBottom = parseInt(getComputedStyle(this.el).bottom);
    });
    this.reset();

    window.addEventListener('scroll', this.checkScrollPoint.bind(this), false);
    window.addEventListener('resize', this.reset.bind(this), false);
  }

  /**
   * @instance
   * @private
   */
  checkScrollPoint() {
    if(document.documentElement.classList.contains('is-mw-lock')) return;

    const winScrollY = window.pageYOffset;
    const elStyle    = this.el.style;

    if(this.showPoint < winScrollY) {
      if(elStyle.display === 'none') {
        this.toggleAnime.run(true);
      }
    }
    else {
      if(elStyle.display === 'block') {
        this.toggleAnime.run(false);
      }
    }

    if(this.stopPoint < winScrollY) {
      elStyle.position = 'absolute';
      elStyle.bottom   = `${this.elBottom}px`
    }
    else {
      elStyle.position = 'fixed';
      elStyle.bottom   = null;
    }
  }

  /**
   * @instance
   * @private
   */
  reset() {
    const winScrollY = window.pageYOffset;

    this.winH = window.innerHeight;

    this.stopPointTop = this.stopPointEl.getBoundingClientRect().top + winScrollY;
    this.stopPoint = this.stopPointTop - this.winH;

    if(typeof this.showPointEl !== 'undefined' && this.showPointEl !== null){
      this.showPointTop = this.showPointEl.getBoundingClientRect().top + winScrollY;
      this.showPoint = this.showPointTop;
    }

    this.checkScrollPoint();
  }

}

/**
 * class exports
 */
module.exports = ToTop;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/ui/to-top.js
 **/